import { gql } from '@apollo/client';

const DELETE_LEGAL_DOCUMENT = gql`
  mutation DeleteLegalDocument($legalDocumentId: Int!) {
    deleteLegalDocument(legalDocumentId: $legalDocumentId)
  }
`;

export default DELETE_LEGAL_DOCUMENT;
